import ActionPanel from '../components/ActionPanel.jsx';
import { ExternalLinkIcon } from '../components/icons.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { PROPERTY_PATH } from '../navigation/paths.js';
import { LEGAL_DOCUMENTS } from './legalLinks.js';

// The Legal section — the Terms & Conditions and the Privacy Notice, opened from
// the Property screen's menu drawer. Built like the help section's link lists
// (help/FaqLinksScreen.jsx): the app's ScreenHeader, then one outward ActionPanel
// per document. The app has no equivalent screen — it shows these links only on
// sign-up and in its terms-review overlay, and web has neither — so this page is
// the whole of the web client's answer to "where do I read the terms?".
//
// Registered OUTSIDE the auth gate (see App.jsx), for two reasons: a legal page
// should be linkable without an account, and the stale-terms notice that links
// here is itself what the gate is showing instead of the dashboard — a page
// inside the gate would just render that notice again.
//
// The back link says "Back" rather than naming a screen: this page is entered
// from the menu drawer (which is not a route on the web), from the stale-terms
// notice, and by direct URL when signed out, so no one destination name is
// honest. It points at the root, which resolves to the Property landing for a
// signed-in user and the sign-in screen for everyone else.
export default function LegalScreen() {
  return (
    <main className="app-shell screen">
      <ScreenHeader
        title="Legal"
        sub="The following links will take you to the Ideal Heating website"
        backTo={PROPERTY_PATH}
      />
      <nav className="action-panel-list" aria-label="Legal documents">
        {LEGAL_DOCUMENTS.map(({ title, href }) => (
          <ActionPanel
            key={href}
            href={href}
            title={title}
            actionIcon={<ExternalLinkIcon />}
          />
        ))}
      </nav>
    </main>
  );
}
